import React from "react";
import "./services.css";

const ServiceIndustries = ({ title, industries = [] }) => {
  return (
    <section className="svc-industries-section">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-duration="800" data-aos-once="true">
          <h2 className="h2-title">{title}</h2>
        </div>

        <div className="row g-4">
          {industries.map((industry, i) => (
            <div
              key={i}
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={`${(i % 2) * 150}`}
              data-aos-once="true"
            >
              <div className="svc-industry-card">
                <div className="svc-industry-icon">
                  <i className={`bi ${industry.icon}`}></i>
                </div>
                <div className="svc-industry-body">
                  <div className="svc-industry-title">{industry.title}</div>
                  <p className="svc-industry-desc">{industry.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceIndustries;
